import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  LIST_ORGANIZATIONS_REQUEST, LIST_ORGANIZATIONS_RESPONSE, LIST_ORGANIZATIONS_RESPONSE_ERROR,
  CREATE_ORGANIZATION_REQUEST, CREATE_ORGANIZATION_RESPONSE,
  UPDATE_ORGANIZATION_REQUEST, UPDATE_ORGANIZATION_RESPONSE,
  ADD_ORGANIZATION_USER_REQUEST, ADD_ORGANIZATION_USER_RESPONSE, ADD_ORGANIZATION_USER_RESPONSE_ERROR,
} from '../constants'

export function listOrganizations() {
  return (dispatch, getState) => {
    if (isCachedItem(getState().orgnanizations)) {
      return
    }
    dispatch({ type: LIST_ORGANIZATIONS_REQUEST })

    axios.get(`${CONFIG.apiBase}/organizations`).then((response) => {
      dispatch({
        type: LIST_ORGANIZATIONS_RESPONSE,
        organizations: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
      dispatch({ type: LIST_ORGANIZATIONS_RESPONSE_ERROR })
    })
  }
}

export function createOrganization(organization) {
  return (dispatch) => {
    dispatch({ type: CREATE_ORGANIZATION_REQUEST, organization })
    axios.post(`${CONFIG.apiBase}/organizations`, organization).then((response) => {
      dispatch({
        type: CREATE_ORGANIZATION_RESPONSE,
        organization: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function updateOrganization(organization) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ORGANIZATION_REQUEST, organization })
    axios.put(`${CONFIG.apiBase}/organizations/${organization.id}`, organization).then((response) => {
      dispatch({
        type: UPDATE_ORGANIZATION_RESPONSE,
        organization: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function addOrganizationUser({ organizationId, email, roleId }) {
  return (dispatch) => {
    dispatch({
      type: ADD_ORGANIZATION_USER_REQUEST,
      organizationId,
      email,
      roleId,
    })
    const payload = {
      email,
      role_id: roleId,
    }
    axios.post(`${CONFIG.apiBase}/organizations/${organizationId}/add_user`, payload).then((response) => {
      dispatch({
        type: ADD_ORGANIZATION_USER_RESPONSE,
        organization: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
      dispatch({ type: ADD_ORGANIZATION_USER_RESPONSE_ERROR })
    })
  }
}
